module.exports = __webpack_public_path__ + "img/78.10.pH.53bd1441.png";